import React from 'react'
import styled from 'styled-components'
import { IconTabs } from '../../assets/icons'

const Tab = styled.div`
  cursor: pointer;
  display: flex;
  width: 100%;
  padding: 12px 5px 12px 16px;
  margin-bottom: 3px;
  border-radius: 4px;
  border: 2px solid transparent;
  background-color: transparent;
  transition: background-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  @media screen and (max-width: 1023px) {
    width: calc(50% - 10px);
  }
  @media screen and (max-width: 800px) {
    width: 100%;
  }

  .tabitem__title {
    margin: 9px 0 0 22px;
    color: var(--white);
    font-family: var(--font-condensed);
    font-size: var(--fz-lg);
    font-weight: 500;
    line-height: 1;
    transition: color 200ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  &.tabitem--design {
    &:hover {
      border: 2px solid var(--grey-hover);
      background-color: var(--grey-hover);
    }
    &.tabitem--active {
      border: 2px solid var(--service-design);
      background-color: var(--service-design);
      box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
    }
  }
  &.tabitem--development {
    &:hover {
      border: 2px solid var(--grey-hover);
      background-color: var(--grey-hover);
    }
    &.tabitem--active {
      border: 2px solid var(--service-development);
      background-color: var(--service-development);
      box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
    }
  }
  &.tabitem--marketing {
    &:hover {
      border: 2px solid var(--grey-hover);
      background-color: var(--grey-hover);
    }
    &.tabitem--active {
      border: 2px solid var(--service-marketing);
      background-color: var(--service-marketing);
      box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
    }
  }
  &.tabitem--support {
    &:hover {
      border: 2px solid var(--grey-hover);
      background-color: var(--grey-hover);
    }
    &.tabitem--active {
      border: 2px solid var(--service-support);
      background-color: var(--service-support);
      box-shadow: 0 0 0 1px rgb(0 0 0 / 1%), 0 25px 25px rgb(0 0 0 / 3%), 0 15px 15px rgb(0 0 0 / 6%), 0 10px 8px rgb(0 0 0 / 5%), 0 4px 4px rgb(0 0 0 / 4%), 0 2px 2px rgb(0 0 0 / 3%);
    }
  }
  @media screen and (max-width: 1023px) {
    &.tabitem--development,
    &.tabitem--support {
      margin-left: 20px;
    }
  }
  @media screen and (max-width: 800px) {
    &.tabitem--development,
    &.tabitem--support {
      margin-left: 0px;
    }
  }
`

const TabItem = ({ icon = '', style = '', title = '', onItemClicked = () => console.error('You passed no action to the component'), isActive = false }) => {
  return (
    <Tab className={isActive ? `tabitem--${style} tabitem--active` : `tabitem--${style}`} onClick={onItemClicked}>
      <IconTabs name={icon} />
      <p className="tabitem__title">{title}</p>
    </Tab>
  )
}

export default TabItem
